import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from './cropImageHelper'; // Helper function to crop the image
import { Button } from 'antd';

const ImageCropper = ({ imageSrc, onClick, aspect }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1); // Zoom level state
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImageResult = await getCroppedImg(imageSrc, croppedAreaPixels);
      setCroppedImage(croppedImageResult.base64); // Set the base64 result for image preview
      console.log('results', croppedImageResult.base64);

      return croppedImageResult; // Return the cropped image for submission
    } catch (e) {
      console.error("Error cropping the image:", e);
    }
  }, [imageSrc, croppedAreaPixels]);

  const handleCroppedImageSubmit = async () => {
    const croppedImageResult = await showCroppedImage(); // Generate the cropped image
    if (croppedImageResult && onClick) {
      onClick(croppedImageResult.base64); // Pass the base64 cropped image to the parent
      console.log('submit', croppedImageResult.base64);
    } else {
      console.error("Cropped image is not available for submission.");
    }
  };

  const handleZoomChange = (e) => {
    setZoom(e.target.value); // Update the zoom level when the slider changes
  };

  return (
    <div className="cropper-container">
      {imageSrc && (
        <>
          <div className="cropper-wrapper">
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={aspect}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          {/* Slider for adjusting the zoom level */}
          <div className="zoom-slider">
            <label htmlFor="zoomRange">Zoom: {zoom}</label>
            <input
              type="range"
              id="zoomRange"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={handleZoomChange}
            />
          </div>

          <Button type="primary" onClick={handleCroppedImageSubmit}>
            Submit Cropped Image
          </Button>
        </>
      )}
    </div>
  );
};

export default ImageCropper;
